import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { AppUpdate } from 'src/app/services/app-updates.service';
import { BlurImageComponent } from 'src/app/components/blur-image/blur-image.component';

/**
 * Modal shown on app entry for an announcement with displayMode = popup.
 * Closing it (or pressing the CTA) resolves the dialog; the caller marks the
 * announcement as read. Returns the link to open when the CTA is pressed.
 */
@Component({
	selector: 'app-app-update-popup',
	standalone: true,
	imports: [CommonModule, MatDialogModule, MatButtonModule, BlurImageComponent],
	template: `
		<div class="relative">
			<button
				type="button"
				(click)="close()"
				class="absolute z-10 flex items-center justify-center w-8 h-8 text-white rounded-full top-2 right-2 bg-black/40"
				aria-label="Cerrar"
			>
				✕
			</button>

			@if (data.imageUrl) {
				<app-blur-image
					[src]="data.imageUrl"
					[placeholder]="data.imageThumbUrl"
					[alt]="data.title"
					imgClass="object-contain w-full max-h-80"
				/>
			}

			<div class="p-5">
				<h1 mat-dialog-title class="!mb-2 text-lg font-bold text-slate-800">{{ data.title }}</h1>
				<div mat-dialog-content>
					<p style="white-space: pre-line;" class="text-sm text-gray-600">{{ data.description }}</p>
				</div>
				<div mat-dialog-actions class="!justify-end !mt-3">
					@if (data.link) {
						<button mat-button (click)="close()">Cerrar</button>
						<button mat-flat-button color="primary" (click)="openLink()">Ver más</button>
					} @else {
						<button mat-flat-button color="primary" (click)="close()">Entendido</button>
					}
				</div>
			</div>
		</div>
	`,
})
export class AppUpdatePopupComponent {
	constructor(
		private _dialogRef: MatDialogRef<AppUpdatePopupComponent>,
		@Inject(MAT_DIALOG_DATA) public data: AppUpdate
	) {}

	close(): void {
		this._dialogRef.close({ openLink: false });
	}

	openLink(): void {
		this._dialogRef.close({ openLink: true });
	}
}
